import type { PropsWithChildren } from 'react';

import cn from '@/lib/utils/cn';

type Props = PropsWithChildren<{
  color: 'RED' | 'GREEN' | 'YELLOW' | 'NEUTRAL';
  onClick?: VoidFunction;
  className?: string;
}>;

export default function Badge({ color, children, onClick, className }: Props) {
  return (
    <span
      className={cn(
        'flex items-center gap-1.5 rounded-lg px-1.5 py-0.5 text-xs font-medium',
        className,
        {
          ['bg-green-200 text-green-800 dark:bg-green-900 dark:text-green-200']:
            color === 'GREEN',
          ['bg-red-200 text-red-800 dark:bg-red-900 dark:text-red-200']:
            color === 'RED',
          ['bg-yellow-200 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200']:
            color === 'YELLOW',
          ['bg-neutral-200 text-neutral-800 dark:bg-neutral-800 dark:text-neutral-200']:
            color === 'NEUTRAL',
          ['cursor-pointer']: typeof onClick === 'function',
        },
      )}
      onClick={onClick}
    >
      {children}
    </span>
  );
}
